export default function AboutUs() {
  const values = [
    {
      icon: "ri-heart-line",
      title: "Compromiso",
      description: "Dedicados al éxito de cada cliente"
    },
    {
      icon: "ri-shield-check-line",
      title: "Integridad",
      description: "Honestidad y transparencia siempre"
    },
    {
      icon: "ri-team-line",
      title: "Comunidad",
      description: "Unidos con nuestra comunidad"
    },
    {
      icon: "ri-star-line",
      title: "Excelencia",
      description: "Los más altos estándares de calidad"
    }
  ];

  return (
    <section id="about" className="py-20 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-12 items-center mb-20">
          <div>
            <div className="inline-block px-4 py-2 bg-teal-100 text-teal-700 rounded-full text-sm font-medium mb-4">
              Sobre Nosotros
            </div>
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
              VeroTax Services - Su Socio de Confianza en Maryland
            </h2>
            <p className="text-gray-600 mb-6 leading-relaxed">
              VeroTax Services proporciona apoyo profesional y orientación a la comunidad hispana en Maryland. Nuestro objetivo es ofrecer servicios claros, responsables y accesibles, ayudando a los clientes a comprender cada proceso y tomar decisiones informadas.
            </p>
            <p className="text-gray-600 mb-8 leading-relaxed">
              Creemos en la comunicación honesta, la atención personalizada y el servicio respetuoso en cada paso del camino.
            </p>
            <div className="flex flex-wrap gap-4">
              <div className="flex items-center space-x-2">
                <i className="ri-checkbox-circle-fill text-teal-600 text-xl"></i>
                <span className="text-sm text-gray-700 font-medium">Personal Bilingüe</span>
              </div>
              <div className="flex items-center space-x-2">
                <i className="ri-checkbox-circle-fill text-teal-600 text-xl"></i>
                <span className="text-sm text-gray-700 font-medium">Precios Accesibles</span>
              </div>
              <div className="flex items-center space-x-2">
                <i className="ri-checkbox-circle-fill text-teal-600 text-xl"></i>
                <span className="text-sm text-gray-700 font-medium">Atención Personalizada</span>
              </div>
              <div className="flex items-center space-x-2">
                <i className="ri-checkbox-circle-fill text-teal-600 text-xl"></i>
                <span className="text-sm text-gray-700 font-medium">Servicio Respetuoso</span>
              </div>
            </div>
          </div>
          <div className="relative">
            <div className="relative h-[500px] w-full rounded-2xl overflow-hidden shadow-2xl">
              <img
                src="https://public.readdy.ai/ai/img_res/c193319aeab1a1b1850f931de5dc3587.jpg"
                alt="VeroTax Team"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>

        {/* Values */}
        <div className="bg-gradient-to-br from-teal-600 to-teal-700 rounded-2xl p-8 md:p-12 text-white">
          <h3 className="text-3xl font-bold mb-3 text-center">Nuestros Valores</h3>
          <p className="text-teal-100 text-center mb-12">Los principios que guían nuestro trabajo</p>
          <div className="grid md:grid-cols-4 gap-8">
            {values.map((value, index) => (
              <div key={index} className="text-center">
                <div className="w-16 h-16 flex items-center justify-center bg-white/10 backdrop-blur-sm rounded-lg mx-auto mb-4">
                  <i className={`${value.icon} text-3xl`}></i>
                </div>
                <h4 className="font-bold text-lg mb-2">{value.title}</h4>
                <p className="text-sm text-teal-100">{value.description}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Mission */}
        <div className="mt-16 text-center max-w-3xl mx-auto">
          <h3 className="text-2xl font-bold text-gray-900 mb-4">Nuestra Misión</h3>
          <p className="text-gray-600 leading-relaxed">
            Empoderar a la comunidad inmigrante y de habla hispana en Maryland proporcionando servicios profesionales de impuestos y documentación de la más alta calidad. Nos esforzamos por eliminar las barreras lingüísticas y culturales, ofreciendo soluciones accesibles y comprensibles que ayuden a nuestros clientes a alcanzar sus objetivos financieros y legales con confianza.
          </p>
        </div>
      </div>
    </section>
  );
}
